import React from "react";
import { ButtonSpan } from "../Button";
import classnames from "classnames";

const getButtonClasses = (isActive, isLeft = false) =>
  classnames("inline-block flex items-center px-3 border border-grey-md", {
    "border-r-0": isLeft,
    "opacity-50": !isActive,
    "bg-brand": isActive,
  });

export const ToggleReportDateFilter = ({
  dateFilter,
  createdAtOnClick,
  eventDateOnClick,
  EVENT_DATE_FILTER = "event_date_from",
  CREATED_AT_FILTER = "created_at",
}) => {
  const isEventDateActive = dateFilter !== EVENT_DATE_FILTER;
  const isCreatedAtActive = dateFilter !== CREATED_AT_FILTER;

  return (
    <div className="mb-2 xxl:mb-0">
      <div className="flex text-xs min-h-9.5">
        <ButtonSpan
          className={getButtonClasses(isEventDateActive, true)}
          onClick={createdAtOnClick}
        >
          Enquiry Date
        </ButtonSpan>
        <ButtonSpan
          className={getButtonClasses(isCreatedAtActive)}
          onClick={eventDateOnClick}
        >
          Event Date
        </ButtonSpan>
      </div>
    </div>
  );
};
